var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "position-relative" }, [
    (_vm.comment.ownable.id === _vm.loggedInAs.id && !_vm.comment.by_admin) ||
    _vm.loggedInAs.type === "App\\User"
      ? _c(
          "div",
          {
            staticClass: "dropdown position-absolute",
            staticStyle: { top: "0", right: "0" },
          },
          [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "dropdown-menu",
                attrs: { "aria-labelledby": "dropdownMenuButton" },
              },
              [
                _vm.loggedInAs.type === "App\\User"
                  ? _c(
                      "a",
                      {
                        staticClass: "dropdown-item",
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.setAsReview(_vm.comment, 10)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm._f("translate")("Make into review")) +
                            "\n        "
                        ),
                        _c("span", { staticClass: "text-lowercase" }, [
                          _vm._v(
                            "(" + _vm._s(_vm._f("translate")("Positive")) + ")"
                          ),
                        ]),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.loggedInAs.type === "App\\User"
                  ? _c(
                      "a",
                      {
                        staticClass: "dropdown-item",
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.setAsReview(_vm.comment, 5)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm._f("translate")("Make into review")) +
                            "\n        "
                        ),
                        _c("span", { staticClass: "text-lowercase" }, [
                          _vm._v(
                            "(" + _vm._s(_vm._f("translate")("Neutral")) + ")"
                          ),
                        ]),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.loggedInAs.type === "App\\User"
                  ? _c(
                      "a",
                      {
                        staticClass: "dropdown-item",
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.setAsReview(_vm.comment, 1)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm._f("translate")("Make into review")) +
                            "\n        "
                        ),
                        _c("span", { staticClass: "text-lowercase" }, [
                          _vm._v(
                            "(" + _vm._s(_vm._f("translate")("Negative")) + ")"
                          ),
                        ]),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.loggedInAs.type === "App\\User"
                  ? _c("div", { staticClass: "dropdown-divider" })
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "dropdown-item",
                    attrs: { href: "#" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.removeComment(_vm.comment)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm._f("translate")("Delete")) +
                        "\n      "
                    ),
                  ]
                ),
              ]
            ),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "row mb-3" }, [
      _c(
        "div",
        { staticClass: "col-auto" },
        [_c("Avatar", { attrs: { user: _vm.student } })],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col" },
        [
          _c(
            "div",
            [
              _vm.loggedInAs.type === "App\\User" && !_vm.comment.by_admin
                ? _c(
                    "router-link",
                    {
                      staticClass: "fw-bold text-dark",
                      attrs: {
                        to: {
                          name: "students.show",
                          params: { student: _vm.comment.ownable.id },
                        },
                      },
                    },
                    [_vm._v("\n          " + _vm._s(_vm.author) + "\n        ")]
                  )
                : _c("span", { staticClass: "fw-bold" }, [
                    _vm._v(_vm._s(_vm.author)),
                  ]),
              _vm._v(" "),
              _vm.comment.by_admin
                ? _c("i", { staticClass: "fas fa-shield-alt" })
                : _vm._e(),
              _vm._v(" "),
              _c("small", { staticClass: "text-muted" }, [
                _vm._v(_vm._s(_vm.time(_vm.comment.created_at))),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", [
            _c(
              "div",
              {
                staticClass: "mb-0",
                staticStyle: { "white-space": "pre-wrap" },
              },
              [_vm._v(_vm._s(_vm.comment.body))]
            ),
            _vm._v(" "),
            _vm.comment.bunny_id
              ? _c("div", { staticClass: "ratio ratio-16x9 mt-2" }, [
                  !_vm.comment.bunny_status ||
                  [0, 1, 2].includes(_vm.comment.bunny_status)
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "d-flex align-items-center justify-content-center border bg-secondary text-white",
                        },
                        [
                          _c("div", [
                            _c(
                              "div",
                              { staticClass: "mb-3" },
                              [_c("Spinner")],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "mx-5 text-center small" },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm._f("translate")(
                                        "This video is now transcoding. Please reload the page in few minutes to check if it has uploaded correctly."
                                      )
                                    ) +
                                    "\n              "
                                ),
                              ]
                            ),
                          ]),
                        ]
                      )
                    : _c("iframe", {
                        key: _vm.comment.bunny_id,
                        attrs: {
                          src: `https://player.mediadelivery.net/embed/25534/${_vm.comment.bunny_id}?autoplay=false&preload=false`,
                          loading: "lazy",
                          allow:
                            "accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;",
                          allowfullscreen: "true",
                        },
                      }),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "d-flex" },
              [
                _c("Votes", { attrs: { votable: _vm.comment } }),
                _vm._v(" "),
                _c("div", [
                  _c("small", { staticClass: "me-2" }, [
                    _c(
                      "a",
                      {
                        staticClass: "text-uppercase text-dark",
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.toggleReplyCreate.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm._f("translate")("Reply")) +
                            "\n              "
                        ),
                      ]
                    ),
                  ]),
                ]),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("Replies", { ref: "replies", attrs: { comment: _vm.comment } }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "button",
      {
        staticClass: "btn btn-link btn-sm",
        attrs: {
          type: "button",
          id: "dropdownMenuButton",
          "data-bs-toggle": "dropdown",
          "aria-haspopup": "true",
          "aria-expanded": "false",
        },
      },
      [_c("i", { staticClass: "fas fa-ellipsis-h" })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }